import React from "react";

const Image = ({ src, alt, className, style }) => {
    const defaultStyle = { maxWidth: '100%', maxHeight: '100%', display: 'block' };
    const merged = Object.assign({}, defaultStyle, style || {});

    return (
        <img
            style={merged}
            alt={alt}
            src={src}
            className={className}
        />
    )
}

export default Image;